// Icons
import { T } from '../core/theme.js';

export const Icon = {
  calendar: ({
    s = 16,
    c = 'currentColor'
  }) => React.createElement("svg", {
    width: s, height: s, viewBox: "0 0 16 16", fill: "none", stroke: c, strokeWidth: "1.3"
  }, React.createElement("rect", { x: "1.5", y: "2.5", width: "13", height: "12", rx: ".5" }),
     React.createElement("path", { d: "M1.5 6h13M5 1v3M11 1v3M4.5 9h2M9.5 9h2M4.5 12h2" })),
  prism: ({
    s = 16,
    c = 'currentColor'
  }) => React.createElement("svg", {
    width: s, height: s, viewBox: "0 0 16 16", fill: "none", stroke: c, strokeWidth: "1.3"
  }, React.createElement("path", { d: "M8 1.5L14.5 13.5H1.5Z" }),
     React.createElement("path", { d: "M8 1.5V13.5M8 7.5L14.5 13.5" })),
  grid: ({
    s = 16,
    c = 'currentColor'
  }) => React.createElement("svg", {
    width: s,
    height: s,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: c,
    strokeWidth: "1.3"
  }, React.createElement("rect", {
    x: "1",
    y: "1",
    width: "6",
    height: "6",
    rx: ".5"
  }), React.createElement("rect", {
    x: "9",
    y: "1",
    width: "6",
    height: "6",
    rx: ".5"
  }), React.createElement("rect", {
    x: "1",
    y: "9",
    width: "6",
    height: "6",
    rx: ".5"
  }), React.createElement("rect", {
    x: "9",
    y: "9",
    width: "6",
    height: "6",
    rx: ".5"
  })),
  table: ({
    s = 16,
    c = 'currentColor'
  }) => React.createElement("svg", {
    width: s,
    height: s,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: c,
    strokeWidth: "1.3"
  }, React.createElement("rect", {
    x: "1",
    y: "1",
    width: "14",
    height: "14",
    rx: ".5"
  }), React.createElement("line", {
    x1: "1",
    y1: "5.5",
    x2: "15",
    y2: "5.5"
  }), React.createElement("line", {
    x1: "1",
    y1: "10",
    x2: "15",
    y2: "10"
  }), React.createElement("line", {
    x1: "6",
    y1: "1",
    x2: "6",
    y2: "15"
  })),
  log: ({
    s = 16,
    c = 'currentColor'
  }) => React.createElement("svg", {
    width: s,
    height: s,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: c,
    strokeWidth: "1.3"
  }, React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "6.5"
  }), React.createElement("line", {
    x1: "8",
    y1: "4.5",
    x2: "8",
    y2: "8.5"
  }), React.createElement("line", {
    x1: "8",
    y1: "8.5",
    x2: "10.5",
    y2: "8.5"
  })),
  doc: ({
    s = 16,
    c = 'currentColor'
  }) => React.createElement("svg", {
    width: s,
    height: s,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: c,
    strokeWidth: "1.3"
  }, React.createElement("path", {
    d: "M3 1.5h7l3 3V14.5H3z"
  }), React.createElement("path", {
    d: "M10 1.5v3h3"
  }), React.createElement("line", {
    x1: "5.5",
    y1: "7.5",
    x2: "10.5",
    y2: "7.5"
  }), React.createElement("line", {
    x1: "5.5",
    y1: "10.5",
    x2: "10.5",
    y2: "10.5"
  })),
  cog: ({
    s = 16,
    c = 'currentColor'
  }) => React.createElement("svg", {
    width: s,
    height: s,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: c,
    strokeWidth: "1.3"
  }, React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "2.5"
  }), React.createElement("path", {
    d: "M8 1.5v2M8 12.5v2M1.5 8h2M12.5 8h2M3.6 3.6l1.4 1.4M11 11l1.4 1.4M3.6 12.4l1.4-1.4M11 5l1.4-1.4"
  })),
  chev: ({
    s = 12,
    c = 'currentColor',
    d = 'down'
  }) => React.createElement("svg", {
    width: s,
    height: s,
    viewBox: "0 0 12 12",
    fill: "none",
    stroke: c,
    strokeWidth: "1.6",
    style: {
      transform: d === 'up' ? 'rotate(180deg)' : d === 'left' ? 'rotate(90deg)' : d === 'right' ? 'rotate(-90deg)' : 'none',
      transition: 'transform .2s'
    }
  }, React.createElement("path", {
    d: "M2.5 4.5L6 8l3.5-3.5"
  })),
  plus: ({
    s = 14,
    c = 'currentColor'
  }) => React.createElement("svg", {
    width: s,
    height: s,
    viewBox: "0 0 14 14",
    fill: "none",
    stroke: c,
    strokeWidth: "1.6"
  }, React.createElement("line", {
    x1: "7",
    y1: "1.5",
    x2: "7",
    y2: "12.5"
  }), React.createElement("line", {
    x1: "1.5",
    y1: "7",
    x2: "12.5",
    y2: "7"
  })),
  check: ({
    s = 12,
    c = T.green
  }) => React.createElement("svg", {
    width: s,
    height: s,
    viewBox: "0 0 12 12",
    fill: "none",
    stroke: c,
    strokeWidth: "2"
  }, React.createElement("path", {
    d: "M1.5 6L4.5 9.5L10.5 2.5"
  })),
  link: ({
    s = 13,
    c = 'currentColor'
  }) => React.createElement("svg", {
    width: s,
    height: s,
    viewBox: "0 0 14 14",
    fill: "none",
    stroke: c,
    strokeWidth: "1.4"
  }, React.createElement("path", {
    d: "M5.5 8.5L8.5 5.5M6 4H4a2 2 0 000 4h1M8 10h2a2 2 0 000-4H9"
  })),
  users: ({
    s = 16,
    c = 'currentColor'
  }) => React.createElement("svg", {
    width: s,
    height: s,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: c,
    strokeWidth: "1.3"
  }, React.createElement("circle", {
    cx: "6",
    cy: "5",
    r: "2.5"
  }), React.createElement("path", {
    d: "M1 13c0-2.76 2.24-4 5-4s5 1.24 5 4"
  }), React.createElement("circle", {
    cx: "12",
    cy: "5",
    r: "2"
  }), React.createElement("path", {
    d: "M14.5 12.5c0-1.93-1.12-3-2.5-3"
  })),
  plug: ({
    s = 16,
    c = 'currentColor'
  }) => React.createElement("svg", {
    width: s,
    height: s,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: c,
    strokeWidth: "1.3"
  }, React.createElement("path", {
    d: "M8 10v4M6 14h4M5 7H3a2 2 0 000 4h10a2 2 0 000-4h-2"
  }), React.createElement("line", {
    x1: "6",
    y1: "2",
    x2: "6",
    y2: "7"
  }), React.createElement("line", {
    x1: "10",
    y1: "2",
    x2: "10",
    y2: "7"
  })),
  key: ({
    s = 16,
    c = 'currentColor'
  }) => React.createElement("svg", {
    width: s,
    height: s,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: c,
    strokeWidth: "1.3"
  }, React.createElement("circle", {
    cx: "5.5",
    cy: "8.5",
    r: "3.5"
  }), React.createElement("path", {
    d: "M8.5 6.5L14 1M12 3.5l1.5 1.5M10.5 2l1.5 1.5"
  })),
  shield: ({
    s = 16,
    c = 'currentColor'
  }) => React.createElement("svg", {
    width: s,
    height: s,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: c,
    strokeWidth: "1.3"
  }, React.createElement("path", {
    d: "M8 1.5L2 4v4c0 3.31 2.69 6 6 7.5C14 14 14 11.31 14 8V4L8 1.5z"
  })),
  refresh: ({
    s = 14,
    c = 'currentColor'
  }) => React.createElement("svg", {
    width: s,
    height: s,
    viewBox: "0 0 14 14",
    fill: "none",
    stroke: c,
    strokeWidth: "1.5"
  }, React.createElement("path", {
    d: "M1.5 7A5.5 5.5 0 0112 3.5"
  }), React.createElement("path", {
    d: "M12.5 7A5.5 5.5 0 012 10.5"
  }), React.createElement("path", {
    d: "M11 1.5l1 2-2 1"
  }), React.createElement("path", {
    d: "M3 12.5l-1-2 2-1"
  })),
  trash: ({
    s = 14,
    c = 'currentColor'
  }) => React.createElement("svg", {
    width: s,
    height: s,
    viewBox: "0 0 14 14",
    fill: "none",
    stroke: c,
    strokeWidth: "1.4"
  }, React.createElement("path", {
    d: "M2 3.5h10M5 3.5V2h4v1.5M5.5 6v4.5M8.5 6v4.5M3 3.5l.7 8.5h6.6l.7-8.5"
  })),
  quote: ({
    s = 16,
    c = 'currentColor'
  }) => React.createElement("svg", {
    width: s,
    height: s,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: c,
    strokeWidth: "1.3"
  }, React.createElement("path", {
    d: "M4 1.5h5.5L13 5v9.5H4z"
  }), React.createElement("path", {
    d: "M9.5 1.5V5H13"
  }), React.createElement("line", {
    x1: "6",
    y1: "8",
    x2: "11",
    y2: "8"
  }), React.createElement("line", {
    x1: "6",
    y1: "10.5",
    x2: "11",
    y2: "10.5"
  }), React.createElement("line", {
    x1: "6",
    y1: "13",
    x2: "9",
    y2: "13"
  })),
  receipt: ({
    s = 16,
    c = 'currentColor'
  }) => React.createElement("svg", {
    width: s,
    height: s,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: c,
    strokeWidth: "1.3"
  }, React.createElement("path", {
    d: "M3 1.5h10v13l-1.7-1.1-1.6 1.1-1.7-1.1-1.6 1.1-1.7-1.1L3 14.5z"
  }), React.createElement("line", {
    x1: "5.5",
    y1: "5",
    x2: "10.5",
    y2: "5"
  }), React.createElement("line", {
    x1: "5.5",
    y1: "7.8",
    x2: "10.5",
    y2: "7.8"
  }), React.createElement("line", {
    x1: "5.5",
    y1: "10.6",
    x2: "8.5",
    y2: "10.6"
  })),
  edit: ({
    s = 14,
    c = 'currentColor'
  }) => React.createElement("svg", {
    width: s,
    height: s,
    viewBox: "0 0 14 14",
    fill: "none",
    stroke: c,
    strokeWidth: "1.4"
  }, React.createElement("path", {
    d: "M9.5 2L12 4.5l-7.5 7.5H2V9.5L9.5 2z"
  }), React.createElement("path", {
    d: "M8 3.5L10.5 6"
  }))
};
